
























































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AppMediumsModule } from '@/store/Settings/AppMediumsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import CreateAppMediumRequest from '@/models/Settings/AppMediums/CreateAppMediumRequest';
import AppMediumState from "@/models/Settings/AppMediums/AppMediumState";
import AppMediumType from "@/models/Settings/AppMediums/AppMediumType";
import ListUtils from '@/lib/listUtils';
import PageNames from '@/router/PageNames';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AppMediumCreate' })
export default class extends SaascadaVueDialog {

    dialog = false;
    isAppMediumEnabled = true;
    request: CreateAppMediumRequest = new CreateAppMediumRequest();
    AppMediumType = AppMediumType;
    whitelistAsString = "";

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.request = new CreateAppMediumRequest();
            this.isAppMediumEnabled = true;
        }
    }

    get appMediumTypes() {
        const allowUxApiAccess = AuthModule.me.institution.config.uxApiAccess && PermissionUtils.allowUxApiAccess();
        return ListUtils.appMediumTypes(AuthModule.me.institution.config.fiApiAccess, allowUxApiAccess);
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Construct the whitelist
            if (this.whitelistAsString !== '' ) {
                if (this.whitelistAsString.lastIndexOf(',') === 0) {
                    this.request.whitelist.push(this.whitelistAsString);
                }
                else {
                    this.request.whitelist = this.whitelistAsString.split(',');
                }
            }

            // Set the other fields on the request
            this.request.state = this.isAppMediumEnabled ? AppMediumState.Enabled : AppMediumState.Disabled;
            this.request.accessTokenLifetime = Number(this.request.accessTokenLifetime);
            this.request.refreshTokenLifetime = Number(this.request.refreshTokenLifetime);

            // Base64 encode the CSR
            this.request.csr = btoa(this.request.csr);

            // Create the new app medium
            await AppMediumsModule.createAppMedium(this.request);

            if (AppMediumsModule.newAppMediumId !== null) {
                this.$router.push({ name: PageNames.AppMedium, params: { id: AppMediumsModule.newAppMediumId } });
            }
        }
    }

}
